module.exports = __webpack_public_path__ + "static/media/micheal.e7be16ce.jpeg";